import { Shop } from "@/types/v2";

/**
 * The layout builder's linkable-label list: the shop's real Tekmetric label
 * catalog (as pushed by the Superpowers extension) when populated, falling
 * back to the legacy, name-only customLabels list otherwise (a Tekmetric
 * shop that hasn't synced Superpowers yet, or a non-Tekmetric integrator
 * with a working getLabels() and no labelCatalog concept at all).
 */
export function getLinkableLabels(
  shop: Pick<Shop, "labelCatalog" | "customLabels">
): string[] {
  if (shop.labelCatalog?.length) {
    return shop.labelCatalog.map((label) => label.name);
  }
  return shop.customLabels ?? [];
}
